export const TABS = {
  ALL: 'ALL',
  ORDERS: 'ORDERS',
  ORDER_ITEMS: 'ORDER_ITEMS',
  PARTS: 'PARTS',
  QUOTES: 'QUOTES',
  QUOTE_ITEMS: 'QUOTE_ITEMS',
  SHARES: 'SHARES',
} as const;

export const DEFAULT_FILTER_SIZE = 4;

export const PAGINATION_SIZES = {
  FULL: 10,
  SHORT: 3,
};

export const DEFAULT_PAGINATION_PARAMS = {
  paginateFrom: 0,
  paginateSize: PAGINATION_SIZES.SHORT,
};

export const TAB_QUERY_KEY_MAP = {
  [TABS.QUOTES]: 'quotes',
  [TABS.QUOTE_ITEMS]: 'quoteItems',
  [TABS.ORDERS]: 'orders',
  [TABS.ORDER_ITEMS]: 'orderItems',
  [TABS.PARTS]: 'parts',
  [TABS.SHARES]: 'shares',
} as const;
